import { createSelector } from 'reselect';
import { getState } from './state';

export const getStorageSlice = createSelector([getState], slice => {
  return slice.storage;
});

export const getEnterHandling = createSelector(getStorageSlice, state => {
  return state?.enterHandling;
});

export const getCanConnectToDamz = createSelector(getStorageSlice, state => {
  return state?.canConnectToDamz;
});
